"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MT = void 0;
exports.MT = {
    numericCode: '470',
    alpha2Code: 'MT',
    alpha3Code: 'MLT',
    englishName: {
        short: 'Malta',
        full: 'the Republic of Malta',
    },
    names: {
        full: {
            en: 'the Republic of Malta',
            fr: 'la République de Malte',
            mt: 'Malta',
        },
        short: {
            en: 'Malta',
            fr: 'Malte',
            mt: 'Malta',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'mt',
            languageAlpha3Code: 'mlt',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'MT-01': {
            numericCode: '470',
            code: 'MT-01',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Attard',
                mt: 'Attard',
            },
        },
        'MT-02': {
            numericCode: '470',
            code: 'MT-02',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Balzan',
                mt: 'Balzan',
            },
        },
        'MT-03': {
            numericCode: '470',
            code: 'MT-03',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Birgu',
                mt: 'Birgu',
            },
        },
        'MT-04': {
            numericCode: '470',
            code: 'MT-04',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Birkirkara',
                mt: 'Birkirkara',
            },
        },
        'MT-05': {
            numericCode: '470',
            code: 'MT-05',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Birżebbuġa',
                mt: 'Birżebbuġa',
            },
        },
        'MT-06': {
            numericCode: '470',
            code: 'MT-06',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bormla',
                mt: 'Bormla',
            },
        },
        'MT-07': {
            numericCode: '470',
            code: 'MT-07',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Dingli',
                mt: 'Dingli',
            },
        },
        'MT-08': {
            numericCode: '470',
            code: 'MT-08',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Fgura',
                mt: 'Fgura',
            },
        },
        'MT-09': {
            numericCode: '470',
            code: 'MT-09',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Floriana',
                mt: 'Floriana',
            },
        },
        'MT-10': {
            numericCode: '470',
            code: 'MT-10',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Fontana',
                mt: 'Fontana',
            },
        },
        'MT-11': {
            numericCode: '470',
            code: 'MT-11',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gudja',
                mt: 'Gudja',
            },
        },
        'MT-12': {
            numericCode: '470',
            code: 'MT-12',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gżira',
                mt: 'Gżira',
            },
        },
        'MT-13': {
            numericCode: '470',
            code: 'MT-13',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Għajnsielem',
                mt: 'Għajnsielem',
            },
        },
        'MT-14': {
            numericCode: '470',
            code: 'MT-14',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Għarb',
                mt: 'Għarb',
            },
        },
        'MT-15': {
            numericCode: '470',
            code: 'MT-15',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Għargħur',
                mt: 'Għargħur',
            },
        },
        'MT-16': {
            numericCode: '470',
            code: 'MT-16',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Għasri',
                mt: 'Għasri',
            },
        },
        'MT-17': {
            numericCode: '470',
            code: 'MT-17',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Għaxaq',
                mt: 'Għaxaq',
            },
        },
        'MT-18': {
            numericCode: '470',
            code: 'MT-18',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ħamrun',
                mt: 'Ħamrun',
            },
        },
        'MT-19': {
            numericCode: '470',
            code: 'MT-19',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Iklin',
                mt: 'Iklin',
            },
        },
        'MT-20': {
            numericCode: '470',
            code: 'MT-20',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Isla',
                mt: 'Isla',
            },
        },
        'MT-21': {
            numericCode: '470',
            code: 'MT-21',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kalkara',
                mt: 'Kalkara',
            },
        },
        'MT-22': {
            numericCode: '470',
            code: 'MT-22',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kerċem',
                mt: 'Kerċem',
            },
        },
        'MT-23': {
            numericCode: '470',
            code: 'MT-23',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kirkop',
                mt: 'Kirkop',
            },
        },
        'MT-24': {
            numericCode: '470',
            code: 'MT-24',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Lija',
                mt: 'Lija',
            },
        },
        'MT-25': {
            numericCode: '470',
            code: 'MT-25',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Luqa',
                mt: 'Luqa',
            },
        },
        'MT-26': {
            numericCode: '470',
            code: 'MT-26',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Marsa',
                mt: 'Marsa',
            },
        },
        'MT-27': {
            numericCode: '470',
            code: 'MT-27',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Marsaskala',
                mt: 'Marsaskala',
            },
        },
        'MT-28': {
            numericCode: '470',
            code: 'MT-28',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Marsaxlokk',
                mt: 'Marsaxlokk',
            },
        },
        'MT-29': {
            numericCode: '470',
            code: 'MT-29',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mdina',
                mt: 'Mdina',
            },
        },
        'MT-30': {
            numericCode: '470',
            code: 'MT-30',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mellieħa',
                mt: 'Mellieħa',
            },
        },
        'MT-31': {
            numericCode: '470',
            code: 'MT-31',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mġarr',
                mt: 'Mġarr',
            },
        },
        'MT-32': {
            numericCode: '470',
            code: 'MT-32',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mosta',
                mt: 'Mosta',
            },
        },
        'MT-33': {
            numericCode: '470',
            code: 'MT-33',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mqabba',
                mt: 'Mqabba',
            },
        },
        'MT-34': {
            numericCode: '470',
            code: 'MT-34',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Msida',
                mt: 'Msida',
            },
        },
        'MT-35': {
            numericCode: '470',
            code: 'MT-35',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mtarfa',
                mt: 'Mtarfa',
            },
        },
        'MT-36': {
            numericCode: '470',
            code: 'MT-36',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Munxar',
                mt: 'Munxar',
            },
        },
        'MT-37': {
            numericCode: '470',
            code: 'MT-37',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Nadur',
                mt: 'Nadur',
            },
        },
        'MT-38': {
            numericCode: '470',
            code: 'MT-38',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Naxxar',
                mt: 'Naxxar',
            },
        },
        'MT-39': {
            numericCode: '470',
            code: 'MT-39',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Paola',
                mt: 'Paola',
            },
        },
        'MT-40': {
            numericCode: '470',
            code: 'MT-40',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Pembroke',
                mt: 'Pembroke',
            },
        },
        'MT-41': {
            numericCode: '470',
            code: 'MT-41',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Pietà',
                mt: 'Pietà',
            },
        },
        'MT-42': {
            numericCode: '470',
            code: 'MT-42',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Qala',
                mt: 'Qala',
            },
        },
        'MT-43': {
            numericCode: '470',
            code: 'MT-43',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Qormi',
                mt: 'Qormi',
            },
        },
        'MT-44': {
            numericCode: '470',
            code: 'MT-44',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Qrendi',
                mt: 'Qrendi',
            },
        },
        'MT-45': {
            numericCode: '470',
            code: 'MT-45',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Rabat Gozo',
                mt: 'Rabat Għawdex',
            },
        },
        'MT-46': {
            numericCode: '470',
            code: 'MT-46',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Rabat Malta',
                mt: 'Rabat Malta',
            },
        },
        'MT-47': {
            numericCode: '470',
            code: 'MT-47',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Safi',
                mt: 'Safi',
            },
        },
        'MT-48': {
            numericCode: '470',
            code: 'MT-48',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: "Saint Julian's",
                mt: 'San Ġiljan',
            },
        },
        'MT-49': {
            numericCode: '470',
            code: 'MT-49',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint John',
                mt: 'San Ġwann',
            },
        },
        'MT-50': {
            numericCode: '470',
            code: 'MT-50',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint Lawrence',
                mt: 'San Lawrenz',
            },
        },
        'MT-51': {
            numericCode: '470',
            code: 'MT-51',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: "Saint Paul's Bay",
                mt: 'San Pawl il-Baħar',
            },
        },
        'MT-52': {
            numericCode: '470',
            code: 'MT-52',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Sannat',
                mt: 'Sannat',
            },
        },
        'MT-53': {
            numericCode: '470',
            code: 'MT-53',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: "Saint Lucia's",
                mt: 'Santa Luċija',
            },
        },
        'MT-54': {
            numericCode: '470',
            code: 'MT-54',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Santa Venera',
                mt: 'Santa Venera',
            },
        },
        'MT-55': {
            numericCode: '470',
            code: 'MT-55',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Siġġiewi',
                mt: 'Siġġiewi',
            },
        },
        'MT-56': {
            numericCode: '470',
            code: 'MT-56',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Sliema',
                mt: 'Sliema',
            },
        },
        'MT-57': {
            numericCode: '470',
            code: 'MT-57',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Swieqi',
                mt: 'Swieqi',
            },
        },
        'MT-58': {
            numericCode: '470',
            code: 'MT-58',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: "Ta' Xbiex",
                mt: "Ta' Xbiex",
            },
        },
        'MT-59': {
            numericCode: '470',
            code: 'MT-59',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tarxien',
                mt: 'Tarxien',
            },
        },
        'MT-60': {
            numericCode: '470',
            code: 'MT-60',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Valletta',
                mt: 'Valletta',
            },
        },
        'MT-61': {
            numericCode: '470',
            code: 'MT-61',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Xagħra',
                mt: 'Xagħra',
            },
        },
        'MT-62': {
            numericCode: '470',
            code: 'MT-62',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Xewkija',
                mt: 'Xewkija',
            },
        },
        'MT-63': {
            numericCode: '470',
            code: 'MT-63',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Xgħajra',
                mt: 'Xgħajra',
            },
        },
        'MT-64': {
            numericCode: '470',
            code: 'MT-64',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Żabbar',
                mt: 'Żabbar',
            },
        },
        'MT-65': {
            numericCode: '470',
            code: 'MT-65',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Żebbuġ Gozo',
                mt: 'Żebbuġ Għawdex',
            },
        },
        'MT-66': {
            numericCode: '470',
            code: 'MT-66',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Żebbuġ Malta',
                mt: 'Żebbuġ Malta',
            },
        },
        'MT-67': {
            numericCode: '470',
            code: 'MT-67',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Żejtun',
                mt: 'Żejtun',
            },
        },
        'MT-68': {
            numericCode: '470',
            code: 'MT-68',
            category: {
                id: '280',
                names: {
                    en: {
                        singular: 'local council',
                        plural: 'local councils',
                    },
                    fr: {
                        singular: 'conseil local',
                        plural: '',
                    },
                    mt: {
                        singular: 'kunsill lokali',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Żurrieq',
                mt: 'Żurrieq',
            },
        },
    },
    cities: [
        {
            name: 'Żabbar',
            subdivision: 'Ħaż-Żabbar',
        },
        {
            name: 'Valletta',
            subdivision: 'Il-Belt Valletta',
        },
        {
            name: 'Qormi',
            subdivision: 'Qormi',
        },
        {
            name: 'Mosta',
            subdivision: 'Il-Mosta',
        },
        {
            name: 'Birkirkara',
            subdivision: 'Birkirkara',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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